import { VendorDeleteUseCase } from '../../../../application';

export default class VendorDeleteService {

    async execute(event) {
        const data = await VendorDeleteUseCase(event);
        return data;
    }
}
